/* Peptagon collection - keep our sticky control bar and filter rail below the
   theme's own sticky header instead of underneath it.

   The Plug theme pins its header to the top of the viewport, and its height
   changes (the nav wraps to two rows at some widths, and some variants only
   turn sticky after a scroll), so it is measured live rather than hard-coded.
   Writes --pgc-sticky-top on .pgc; the CSS falls back to 16px.

   GAP is 0 on purpose: any gap between the header and the parked bar becomes a
   window that page content scrolls through, which reads as a glitch. Docking
   the bar flush under the nav keeps that strip clean. */
(function(){
  'use strict';
  var root = document.querySelector('[data-pgc]');
  if (!root) return;

  var GAP = 0;
  var SEL = 'header, .header, .site-header, sticky-header, [class*="header"], [id*="header"], [class*="navbar"]';
  var last = -1, ticking = false;

  function headerBottom(){
    var els = document.querySelectorAll(SEL), best = 0;
    for (var i = 0; i < els.length; i++){
      var el = els[i];
      if (root.contains(el) || el.contains(root)) continue;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') continue;
      var r = el.getBoundingClientRect();
      if (r.height < 24 || r.height > 240) continue;
      if (r.top > 8 || r.bottom <= 0) continue;
      if (r.width < window.innerWidth * 0.6) continue;
      if (r.bottom > best) best = r.bottom;
    }
    return best;
  }

  function update(){
    ticking = false;
    var b = headerBottom();
    var top = b ? Math.round(b) + GAP : 16;   // 16px when no sticky header
    if (top === last) return;
    last = top;
    root.style.setProperty('--pgc-sticky-top', top + 'px');
  }

  function schedule(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  update();
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  addEventListener('load', schedule);
  setTimeout(update, 400);
  setTimeout(update, 1200);
})();
